<app-loader [loading]="loading"></app-loader>
@if (user) {
    <form [formGroup]="form">
        <div class="flex flex-col gap-2">
            <div class="flex align-center justify-between">
                <div class="flex gap-2 items-center w-full">
                    <app-avatar [name]="user.name"></app-avatar>
                    @if (editMode) {
                        <app-verifiable-input group="create-user" field="name" class="w-full">
                            <input pInputText id="name" formControlName="name" class="w-full" />
                        </app-verifiable-input>
                    } @else {
                        <span class="font-semibold text-lg">{{ user.name }}</span>
                    }
                </div>
                @if (!editMode) {
                    <p-button size="small"
                              class="flex"
                              label="Edit"
                              icon="pi pi-pencil"
                              [outlined]="true"
                              (onClick)="toggleEdit()">
                    </p-button>
                }
            </div>
            <div class="flex flex-wrap mt-3">
                <div class="flex flex-col col-4 gap-2">
                    <span class="text-gray-500">Status</span>
                    <app-status [value]="user.status"></app-status>
                </div>
                <div class="flex flex-col col-4 gap-2">
                    <span class="text-gray-500">Email</span>
                    <a href="mailto:{{ user.email }}">{{ user.email }}</a>
                </div>

                <div class="flex flex-col col-4 gap-2">
                    <span class="text-gray-500">Role</span>
                    <app-role [value]="user.role"></app-role>
                </div>

                <div class="flex flex-col col-4 gap-2">
                    <span class="text-gray-500">Phone</span>
                    @if (editMode) {
                        <input pInputText id="phone" formControlName="phone" [imask]="mask" />
                    } @else {
                        @if (user.phone) {
                            <a href="tel:{{ user.phone }}">{{ user.phone }}</a>
                        } @else {
                            <span>{{ user.phone  | valueOr }}</span>
                        }
                    }
                </div>

                <div class="flex flex-col col-4 gap-2">
                    <span class="text-gray-500">Auth Provider</span>
                    <span>{{ user.auth_provider }}</span>
                </div>

                <div class="flex flex-col col-4 gap-2">
                    <span class="text-gray-500">Created At</span>
                    <span>{{ user.created_at | date: 'short' | valueOr }}</span>
                </div>

                <div class="flex flex-col col-4 gap-2">
                    <span class="text-gray-500">Last Login</span>
                    <span>{{ user.last_login | date: 'short' | valueOr }}</span>
                </div>
            </div>
            @if (editMode) {
                <div class="flex align-center justify-end gap-2">
                    <p-button size="small"
                              class="flex"
                              label="Cancel"
                              icon="pi pi-times"
                              [outlined]="true"
                              (onClick)="toggleEdit()">
                    </p-button>
                    <p-button size="small"
                              class="flex"
                              label="Save"
                              icon="pi pi-save"
                              (onClick)="updateProfile()">
                    </p-button>
                </div>
            }
        </div>
    </form>
}
